// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-standalone-text-transform": "uppercase",
	"link-standalone-font-weight": "700",
	"link-disabled-color": "rgb(112, 111, 110)",
	"link-initial-color": "rgb(0, 126, 140)",
	"link-standalone-font-size": "14px",
	"link-bold-font-size": "0.98em",
	"link-standalone-line-height": "20px",
	"link-standalone-letter-spacing": "1.600000023841858px",
	"link-interaction-color": "rgb(0, 99, 115)",
	"link-border-width": "1px"
};
export default ___CSS_LOADER_EXPORT___;
